// removed by extract-text-webpack-plugin
module.exports = {"floatBox":"dgkwYgEraqnap5EFJiDgK","arrow":"_1T7U_4h6YqR2lvhyWhc-dD","active":"_1KCapL9lW9yAW0jqs9rkoL"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/atoms/FloatBox/style.css
// module id = 248
// module chunks = 37